import { createContext, useContext } from "react";

// Context crosses React portals; never change html.light or a saved app preference.
export const ServiceTechThemeContext = createContext(false);
export const useServiceTechThemeClass = () => useContext(ServiceTechThemeContext) ? "service-tech-dark dark" : "";